import classes from './SchedulerBody.module.css';

const SchedulerBody = (props) => {
  return <div className={classes.SchedulerBody}>{props.children}</div>;
};

export default SchedulerBody;
